module.exports = __webpack_public_path__ + "img/infrastructure-bg.959062f4.png";